import { apiClient } from '@app/lib'
import { type ApiResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useSetPhoneNumber = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['setPhoneNumber'],
    mutationFn: async (phoneNumber: string) => {
      const { data } = await apiClient.post<ApiResponse>(`/api/mfa/set_phone_number`, {
        phoneNumber
      })

      return data
    },
    onSuccess: (_, data) => queryClient.setQueryData(['phone'], data)
  })
}
